export default __webpack_public_path__ + "static/media/books2-afterA-768w.0e6b9504.png";